import { Radio } from '@base-ui/react/radio';
import { RadioGroup } from '@base-ui/react/radio-group';
import styles from "./YuJaRadioBox.module.css";

export default function YuJaRadioGroup({data=[], value, disabled=false, onchange, groupStyle={}, labelStyle={}}) {

    return (
        <RadioGroup
            value={value ?? ""}
            onValueChange={(value, e) => onchange(value)}
            className={styles.radioGroup}
            disabled={disabled}
            style={{...groupStyle}}
        >
            {data.map((item, index) => (
                <label key={index} className={styles.Item} style={{...labelStyle}}>
                    <Radio.Root value={item.value} className={styles.Radio}>
                        <Radio.Indicator className={styles.Indicator} keepMounted={true}/>
                    </Radio.Root>
                    {item.label}
                </label>
            ))}
        </RadioGroup>
    );
}